import { Box, Typography, Button, useTheme, useMediaQuery, Stack, styled } from "@mui/material";
import { ReactComponent as BitcoinerCorrect } from "assets/images/bitcoiner/bitcoiner-correct.svg";
import { ReactComponent as BitcoinerWrong } from "assets/images/bitcoiner/bitcoiner-wrong.svg";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useTranslation } from "react-i18next";

import { QuizState } from "..";

const BitcoinerWrongShake = styled(BitcoinerWrong)(() => ({
  width: "150px",
  height: "auto",
  zIndex: 3,
  animation: "shake 0.5s",
  "@keyframes shake": {
    "0%": { transform: "translateX(0)" },
    "20%": { transform: "translateX(-10px)" },
    "40%": { transform: "translateX(10px)" },
    "60%": { transform: "translateX(-10px)" },
    "80%": { transform: "translateX(10px)" },
    "100%": { transform: "translateX(0)" },
  },
}));

export default function QuizResult({
  quizState,
  onClose,
  earned,
}: {
  quizState: QuizState;
  onClose: () => void;
  earned: number;
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { colors } = useMUIThemeModeContext();

  const mainColor = quizState === "correct" ? colors.success : colors.error500;
  const Icon = quizState === "correct" ? BitcoinerCorrect : BitcoinerWrongShake;

  return (
    <>
      <Typography
        fontSize={"2rem"}
        fontWeight={fontWeight.extraBold}
        fontFamily={"Nunito"}
        textAlign={"center"}
        color={mainColor}>
        {t(`bitcoinerChallenge.quiz.${quizState}`)}
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center" mt={{ xs: 4, md: 10 }} position="relative">
        <Icon style={{ width: "150px", height: "auto" }} />
        <Stack direction="row" spacing={1} pt={6}>
          <Typography fontSize={"1.5rem"} fontWeight={fontWeight.bold} fontFamily={"Nunito"}>
            {t("bitcoinerChallenge.quiz.earned")}
          </Typography>
          <Typography fontSize={"1.5rem"} fontWeight={fontWeight.bold} fontFamily={"Nunito"} color={mainColor}>
            {`${earned > 0 ? "+" : ""}${earned} XP`}
          </Typography>
        </Stack>
        <Box display="flex" width={"100%"} justifyContent={{ xs: "center", md: "flex-end" }} mt={{ xs: 4, md: 10 }}>
          <Button
            variant="contained"
            size="large"
            sx={{ fontFamily: "Nunito", fontWeight: fontWeight.bold }}
            onClick={onClose}
            fullWidth={isMobile}>
            {t("bitcoinerChallenge.quiz.back")}
          </Button>
        </Box>
      </Box>
    </>
  );
}
